<div class="call-recordings-container">
  @let brandingData = (brandingService.brandingData$ | async) || defaultBrandingSettings;
  <div>
    <h2>{{ 'CALL_RECORDINGS_PREFERENCES.ANNOUNCEMENTS_SUBHEADER' | translate }}</h2>

    <div class="help-text">{{ 'CALL_RECORDINGS_PREFERENCES.HELP_TEXT' | translate }}</div>

    <div class="method">
      <div class="subheader">{{ 'CALL_RECORDINGS_PREFERENCES.INPUT_METHOD' | translate }}</div>
      <mat-radio-group
        color="primary"
        [(ngModel)]="type"
        (change)="handleTypeChange()">
        <mat-radio-button
          value="tts"
          [style.--branding-color]="brandingData[BrandingField.FieldColorFontIconsListAreaItems]"
          >{{ 'CALL_RECORDINGS_PREFERENCES.METHOD_TTS' | translate }}</mat-radio-button
        >
        <mat-radio-button
          value="files"
          [style.--branding-color]="brandingData[BrandingField.FieldColorFontIconsListAreaItems]"
          >{{ 'CALL_RECORDINGS_PREFERENCES.METHOD_UPLOAD_FILES' | translate }}</mat-radio-button
        >
      </mat-radio-group>
    </div>

    @if (type === 'tts') {
      <form [formGroup]="ttsForm">
        <div class="tts-option">
          <mat-form-field
            class="select density-minus-3"
            appearance="outline"
            floatLabel="always"
            hideRequiredMarker>
            <mat-label>{{ 'CALL_RECORDINGS_PREFERENCES.LANGUAGE' | translate }}</mat-label>
            <mat-select
              formControlName="language"
              (selectionChange)="handleLanguageChange($event)">
              @for (language of recAnnouncementService.languages$ | async; track language.id) {
                <mat-option [value]="language.id">{{ language.name }} ({{ language.country }})</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="tts-option">
          <mat-form-field
            class="select density-minus-3"
            appearance="outline"
            floatLabel="always"
            hideRequiredMarker>
            <mat-label>{{ 'CALL_RECORDINGS_PREFERENCES.VOICE' | translate }}</mat-label>
            <mat-select
              formControlName="voice"
              (selectionChange)="handleVoiceChange()">
              @for (voice of voices; track voice.id) {
                <mat-option [value]="voice.id">{{ voice.name }} ({{ voice.type }})</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="subheader">{{ 'CALL_RECORDINGS_PREFERENCES.ON_DEMAND_ANNOUNCEMENTS' | translate }}</div>
        @for (message of DefaultRecordingAnnouncementSettings.ttsMessages; track message) {
          @if ($last) {
            <div class="subheader">{{ 'CALL_RECORDINGS_PREFERENCES.ALL_CALL_ANNOUNCEMENT' | translate }}</div>
          }
          <div class="tts-item">
            <mat-form-field
              class="density-minus-3"
              appearance="outline"
              floatLabel="always"
              hideRequiredMarker>
              <mat-label>{{ message | translate }}</mat-label>
              <input
                matInput
                [formControl]="ttsMessages.value.at($index)"
                (ngModelChange)="handleMessageChange()" />
              @if (states[$index].inProgress) {
                <mat-spinner
                  matSuffix
                  diameter="20" />
              } @else {
                <mat-icon
                  color="primary"
                  matSuffix
                  [ngClass]="{
                    disabled:
                      states[$index].playing ||
                      ttsMessages.value.at($index).invalid ||
                      language?.invalid ||
                      voice?.invalid,
                  }"
                  (click)="handleTTSPlay($index)"
                  appBrandingColor
                  [brandingField]="BrandingField.FieldColorFontIconsListAreaItems"
                  styleType="color">
                  play_arrow
                </mat-icon>
              }
            </mat-form-field>
          </div>
        }
      </form>
    } @else {
      <input
        type="file"
        #fileInput
        accept=".wav"
        (change)="handleFileInput($event)"
        [style.display]="'none'" />
      <div class="options">
        <div class="subheader">{{ 'CALL_RECORDINGS_PREFERENCES.ON_DEMAND_ANNOUNCEMENTS' | translate }}</div>
        @for (message of DefaultRecordingAnnouncementSettings.ttsMessages; track message) {
          @if ($last) {
            <div class="subheader">{{ 'CALL_RECORDINGS_PREFERENCES.ALL_CALL_ANNOUNCEMENT' | translate }}</div>
          }
          <div class="item">
            <div class="label">{{ message | translate }}</div>
            <div class="buttons">
              <mat-icon
                color="primary"
                [ngClass]="{ disabled: states[$index].playing || !fileAnnouncements[$index].blob }"
                (click)="handlePlay($index)"
                appBrandingColor
                [brandingField]="BrandingField.FieldColorFontIconsListAreaItems"
                styleType="color">
                play_arrow
              </mat-icon>
              <mat-icon
                color="primary"
                [ngClass]="{ disabled: states[$index].inProgress }"
                (click)="handleUpload($index)"
                appBrandingColor
                [brandingField]="BrandingField.FieldColorFontIconsListAreaItems"
                styleType="color">
                upload
              </mat-icon>
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>
